import Vue from 'vue'
import axios from 'axios'
import Router from 'vue-router'
import store from '@/store'
import LandingPage from '@/views/LandingPage.vue'
import SetupReviewPage from '@/views/SetupReviewPage.vue'
import ReviewPage from '@/views/ReviewPage.vue'
import ProjectPage from '@/views/ProjectPage.vue'
import LoginPage from '@/views/LoginPage.vue'
import QuickLookPage from '@/views/QuickLookPage.vue'
import AdminPage from '@/views/AdminPage.vue'
import ProjectToolsPage from '@/views/ProjectToolsPage.vue'
// import CoursePrepPage from '@/views/CoursePrepPage.vue'
import PaymentInfoPage from '@/views/PaymentInfoPage.vue'
import CoursePrepNursingPage from '@/views/CoursePrepNursingPage.vue'
import ErrorPage from '@/views/ErrorPage.vue'

Vue.use(Router)
const apiBaseURL = process.env.VUE_APP_API_URL

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: LandingPage,
      meta: { requiresAuth: true },
    },
    {
      path: '/reviews',
      beforeEnter: () => {
        window.location = 'https://ofditprojects.sps.cuny.edu/next/reviews'
      },
    },
    {
      path: '/reviews/setup/:projectId',
      name: 'setupReview',
      component: SetupReviewPage,
      meta: { requiresAuth: true },
    },
    {
      path: '/reviews/:reviewId',
      name: 'reviewDashboard',
      component: ReviewPage,
      meta: { requiresAuth: true },
    },
    {
      path: '/reviews/:reviewId/ratings/:reviewerRole/:ratingUrl',
      name: 'reviewForm',
      component: ReviewPage,
    },
    {
      path: '/admin/:adminFunction',
      name: 'admin',
      component: AdminPage,
      meta: { requiresAuth: true, requiresAdmin: true },
    },
    {
      path: '/projects/:id',
      name: 'quicklookpage',
      component: QuickLookPage,
      meta: { requiresAuth: true },
    },
    {
      path: '/projects',
      name: 'projects',
      component: ProjectPage,
      meta: { requiresAuth: true },
    },
    {
      path: '/project-tools/:tool',
      name: 'projectTools',
      component: ProjectToolsPage,
      meta: { requiresAuth: true, requiresOfdit: true },
    },
    {
      path: '/payments',
      name: 'payments',
      component: PaymentInfoPage,
      meta: { requiresAuth: true },
    },
    {
      path: '/courseprep',
      name: 'coursePrep',
      beforeEnter() {location.href = 'https://ofditprojects.sps.cuny.edu/next/course-prep'}, 
      meta: { requiresAuth: true },
    },
    {
      path: '/courseprep-nursing',
      name: 'coursePrepNuring',
      component: CoursePrepNursingPage,
      meta: { requiresAuth: true },
    },
    {
      path: '/login',
      name: 'login',
      component: LoginPage,
    },
    {
      path: '/error',
      name: 'error',
      component: ErrorPage,
      props: true,
    },
  ],
  mode: 'history',
})

router.beforeEach(async (to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const user = window.localStorage.getItem('user')
    if (!user) {
      next({
        path: '/login',
        query: { redirect: to.fullPath },
      })
    } else {
      try {
        const { token } = JSON.parse(user)
        const response = await axios({
          url: `${apiBaseURL}/login/check-token`,
          method: 'post',
          data: {
            user_token: token,
          },
        })
        response.data.token = token
        await store.commit('setCurrentUser', response.data)
        window.localStorage.setItem('user', JSON.stringify(response.data))
        next()
      } catch (err) {
        next({
          path: '/login',
          query: { redirect: to.fullPath },
        })
      }
    }
  } else {
    next()
  }
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAdmin)) {
    if (!store.getters.currentUser.is_grizzly_admin) {
      next({
        path: '/login',
        query: { redirect: to.fullPath },
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresOfdit)) {
    if (!store.getters.isOfdit) {
      next({
        path: '/login',
        query: { redirect: to.fullPath },
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAdmin)) {
    if (!store.getters.isOfdit) {
      next({
        path: '/login',
        query: { redirect: to.fullPath },
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
